module.exports = __webpack_public_path__ + "static/media/arrow_lgs.59b7fce2.svg";